export enum AccessLevels {
    Administrator = 'Administrator',
    EventEditor = 'EventEditor',
    EventReader = 'EventReader',
}
